module.exports = __webpack_public_path__ + "img/ic_feedback_message.c4c3e91c.svg";